import React, { useState, useEffect } from "react";
import "../css/CertificateViewer.css"; // Import custom styles
import { doctorSettingAtom } from "../../_helper/constant/constant-atom";
import { useAtom } from "jotai";
import { getImageURL } from "../../_helper/utils/image";
import { calculateAge } from "../../_helper/utils/utils";

export default function CertificateViewer({
  content,
  style,
  userDetails,
  setUpdatedContent,
  header_footer_setup_data,
}) {
  const [formData, setFormData] = useState(userDetails);
  const [updatedHtml, setUpdatedHtml] = useState(content); // Store the updated HTML
  // console.log(userDetails);

  const extractPlaceholders = (htmlContent) => {
    if (!htmlContent || typeof htmlContent !== "string") {
      return {}; // Return empty object if content is invalid
    }

    const regex = /@(\w+)/g; // Matches any placeholder starting with '@'
    const matches = [...htmlContent?.matchAll(regex)];
    const uniqueMatches = [...new Set(matches.map((match) => match[1]))]; // Avoid duplicates

    const initialData = uniqueMatches.reduce((acc, key) => {
      acc[key] = userDetails[key] || ""; // Initialize all placeholders with an empty string
      return acc;
    }, {});

    return initialData;
  };

  // useEffect(() => {
  //   setFormData({ ...formData, full_name: userDetails.full_name });
  // }, [userDetails]);

  // Initialize formData based on the placeholders in the content
  useEffect(() => {
    const placeholders = extractPlaceholders(content);
    // console.log(placeholders);
    setFormData(placeholders);
  }, [content]);

  // Update HTML content whenever formData changes
  useEffect(() => {
    let updatedContent = content;

    Object.keys(formData).forEach((key) => {
      if (key === "age") {
        console.log("Form Data", formData);
        updatedContent = updatedContent?.replaceAll(
          `@${key}`,
          calculateAge(userDetails["dob"]).years || ""
        );
      } else {
        updatedContent = updatedContent?.replaceAll(
          `@${key}`,
          formData[key] || ""
        );
      }
    });

    setUpdatedHtml(updatedContent); // Update the HTML with input values
    setUpdatedContent(updatedContent);
  }, [formData, content, userDetails]);

  // Handler to update form data dynamically when the user types into inputs
  const handleInputChange = (e, key) => {
    const value = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  // console.log(userDetails);

  // Function to render content with placeholders and input fields
  const renderInputFields = () => {
    return (
      <div className="pl-6">
        {Object.keys(formData)?.map((key) => (
          <div key={key} className="input-container p-2">
            <label className="" htmlFor={key}>
              Enter {key.replace("_", " ")}:
            </label>
            <input
              type="text"
              id={key}
              className="mt-1 p-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-400"
              placeholder={key.replace("_", " ")}
              value={formData[key]}
              onChange={(e) => handleInputChange(e, key)}
            />
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="certificate-viewer" style={style}>
      <div className="viewer-container">
        <div className="html-section border-[#ddd] border-solid border-[1px] p-2">
          {header_footer_setup_data?.headerUrl ? (
            <img
              className="w-[100%]"
              src={getImageURL(header_footer_setup_data?.headerUrl)}
            />
          ) : (
            <p className="flex justify-center">
              Not getting header if not please set it from header footer setup!
            </p>
          )}
          {/* Display the updated HTML content */}
          <div
            className="updated-html"
            dangerouslySetInnerHTML={{ __html: updatedHtml }}
          />

          <div className="flex justify-end">
            {header_footer_setup_data?.printSignature &&
            header_footer_setup_data?.signatureImg ? (
              <img src={getImageURL(header_footer_setup_data?.signatureImg)} />
            ) : (
                <p className="flex justify-center">
                  Not getting header if not please set it from header footer
                  setup!
                </p>
              ) || header_footer_setup_data?.signatureText ? (
              header_footer_setup_data?.signatureText
                ?.split("\n")
                .map((line, index) => <div key={index}>{line}</div>)
            ) : (
              <p className="flex justify-center">
                Not getting header if not please set it from header footer
                setup!
              </p>
            )}
          </div>

          <div className="flex justify-end"></div>

          {header_footer_setup_data?.footerURL ? (
            <img
              className="w-[100%]"
              src={getImageURL(header_footer_setup_data?.footerURL)}
            />
          ) : (
            <p className="flex justify-center">
              Not getting Footer if you need so, please set it from header
              footer setup!
            </p>
          )}
        </div>
        <div className="input-container justify-end mt-5">
          {/* Render the input fields on the right */}
          {renderInputFields()}
        </div>
      </div>
    </div>
  );
}
